module.exports = ".stub-status{\r\n  height: 35px;\r\n  border-radius: 0;\r\n  margin-bottom: 0;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/automation-data/automation-data.component.css
// module id = ./src/app/common/components/automation-data/automation-data.component.css
// module chunks = main